import React from 'react';
import { Shape } from '../Slide/SlideContents/shapes/Shape';
import { WordArtTextObject } from '../WordArt';
import { Image } from '../Slide/SlideContents/Image/Image';
import Editor from '../Slide/SlideContents/Editor/Editor';
import { useSelector } from 'react-redux';

const MasterSlideContainer = () => {

    let currentSlideId = useSelector(state => state.slide.currentSlideId);
    let masterSlideId = useSelector(state => state.slide.masterSlideId);
    const activeSlideId = currentSlideId?.toLowerCase().includes('master') ? currentSlideId : masterSlideId;
    const textBoxIds = useSelector((state) => activeSlideId && state.slide.slides[activeSlideId]?.textBoxIds);
    const imageIds = useSelector((state) => activeSlideId && state.slide.slides[activeSlideId]?.imageIds);
    const shapes = useSelector((state) => activeSlideId && state.slide.slides[activeSlideId]?.shapes);
    const wordArtTextObjects = useSelector((state) => activeSlideId && state.slide.slides[activeSlideId]?.wordArtTextObjects);
    const presentMode = useSelector((state) => state.slide.presentMode);
    const slideBackgroundColor = useSelector((state) => activeSlideId && state.slide.slides[activeSlideId]?.slideBackgroundColor);

    return (
        currentSlideId && (
            <div
                className='slide-container'
                id="master-slide"
                style={{
                    backgroundColor: slideBackgroundColor,
                    width: '730px',
                    height: '420px',
                }}
            >
                {textBoxIds && textBoxIds.length > 0 && currentSlideId.includes('master') &&
                    textBoxIds.map((quillId) => (
                        <Editor
                            quillId={quillId}
                            presentMode={presentMode}
                            currentSlideId={currentSlideId}
                            key={quillId}
                        />
                    ))}
                {imageIds && imageIds.length > 0 && currentSlideId.includes('master') &&
                    imageIds.map((imgId) => (
                        <Image key={imgId} imgId={imgId} />
                    ))}
                {shapes && Object.keys(shapes).length !== 0 && currentSlideId.includes('master') &&
                    Object.keys(shapes).map((shapeId) => <Shape key={shapeId} shapeId={shapeId} />)}
                {wordArtTextObjects && Object.keys(wordArtTextObjects).length !== 0 && currentSlideId.includes('master') &&
                    Object.keys(wordArtTextObjects).map((wordArtId) => (
                        <WordArtTextObject key={wordArtId} wordArtId={wordArtId} currentSlideIdProp={activeSlideId} />
                    ))}
            </div>
        )
    )
}

export default MasterSlideContainer;